import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { PaymentListResponse, ProductListResponse, ReceiptListResponse } from './receipts.model';
import { SendDocumentModel } from '../preview-dialog/send-dialog/send-document.model';
import { BaseHttpResponse } from 'src/app/_common/models/core.model';

@Injectable({
  providedIn: 'root'
})

export class ReceiptsService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  getReceipts(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<ReceiptListResponse> {
    return this.http
      .post<ReceiptListResponse>(
        this.apiUrl + 'receipt/receipts',
        {
          pageNumber: pageIndex,
          pageSize,
          sortBy,
          sortDir,
          filter: JSON.stringify(filter)
        }
      );
  }

  getImage(id: number)
  {
    return this.http.get(`${this.apiUrl}receipt/image/${id}`, { observe: 'response', responseType: 'text' });
  }

  send(sendDocumentModel: SendDocumentModel) {
    return this.http.post<BaseHttpResponse<string>>(this.apiUrl + 'receipt/send', sendDocumentModel);
  }

  getProducts(page: number, filter: any): Observable<ProductListResponse> {
    return this.http.get<ProductListResponse>(this.apiUrl + 'receipt/products', 
    {
      params: new HttpParams()
        .set('pageNumber', page.toString())
        .set('pageSize', 100)
        .set('filter', filter)
    });
  }

  getPayments(): Observable<PaymentListResponse> {
    return this.http.get<PaymentListResponse>(this.apiUrl + 'receipt/payments', {});
  }
}
